import type { TFunction } from "i18next";

import { NBSP, THIN_SPACE } from "@/lib/money";

// Цена в ответах помощника — всегда в рублях и словом «руб.», а не знаком:
// так её пишет и сам помощник в тексте ответа. Разряды — узким неразрывным
// пробелом, как во всех ценах витрины (lib/money); подпись валюты — из i18n
// (`assistant.price`).
export const formatRub = (t: TFunction, value: number): string =>
	t("assistant.price", {
		value: new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 })
			.format(value)
			.replace(/[    ]/g, THIN_SPACE),
	});

// Текст ответа модели: «1 627 руб.» пишется обычными пробелами, и на 390px
// строка рвалась посреди числа («— 1» / «627 руб.»). Разряды склеиваем узким
// неразрывным пробелом, число с «руб.» — неразрывным.
export const keepNumbersTogether = (text: string): string =>
	text.replace(/(\d)[ \u00A0](?=\d{3}(?!\d))/g, `$1${THIN_SPACE}`).replace(/(\d) (руб\.|₽)/g, `$1${NBSP}$2`);

/** Узкий экран: таб-бар внизу, панель на весь экран (< 1024px, как MobileTabBar). */
export const isCompactViewport = (): boolean =>
	typeof window !== "undefined" && window.matchMedia("(max-width: 1023px)").matches;
